import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=6a9f8f4c&scoped=true&"
import script from "./TermsModal.vue?vue&type=script&lang=js&"
export * from "./TermsModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsModal.vue?vue&type=style&index=0&id=6a9f8f4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9f8f4c",
  null
  
)

export default component.exports